import { render, staticRenderFns } from "./UdiList.vue?vue&type=template&id=28a0e641"
import script from "./UdiList.vue?vue&type=script&lang=js"
export * from "./UdiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports